// @vendors
const React = require("react");
const PropTypes = require("prop-types");

// @helpers
const { FormattedText } = require("core/i18n").i18n;
const { isValidKey } = require("../componentsUtilities/translationHelper");

// @components
const RiskNumbers = require("./RiskNumbers");

require("./RiskIndicator.scss");

const RiskIndicator = ({
    riskValue,
    regulatoryTextKeyArray,
    isAlternativeFund,
}) => {
    let regulatoryText;
    if (regulatoryTextKeyArray.length !== 0) {
        const regularyTexts = regulatoryTextKeyArray.map(
            (regulatoryTextKey, index) => {
                return isValidKey(regulatoryTextKey) ? (
                    <p key={index}>
                        <FormattedText
                            className="risk-indicator-risk-content__regulatory-text"
                            value={regulatoryTextKey}
                        />
                    </p>
                ) : null;
            }
        );
        regulatoryText = (
            <div className="risk-indicator-risk-content__regulatory-text-container">
                {regularyTexts}
            </div>
        );
    }

    return (
        <div className="risk-indicator-container">
            <div className="risk-indicator-container__title">
                <FormattedText value="fundsCard-riskIndicatorFunds_title" />
            </div>
            <div className="risk-indicator-container__content">
                <div className="risk-indicator-risk-numbers">
                    <RiskNumbers riskValue={riskValue} />
                    <div className="risk-indicator-risk-numbers__risk-text">
                        <FormattedText value="fundsCard-riskIndicatorFunds_minorRisk" />
                        <FormattedText value="fundsCard-riskIndicatorFunds_majorRisk" />
                    </div>
                </div>
                <div className="risk-indicator-risk-content">
                    {isAlternativeFund ? (
                        <FormattedText
                            value="brokerAlternativeFundsCard-riskIndicatorFunds_content"
                            className="risk-indicator-risk-content__alternative-fund-text"
                        />
                    ) : (
                        <FormattedText value="fundsCard-riskIndicatorFunds_content" />
                    )}

                    {regulatoryText}
                </div>
            </div>
        </div>
    );
};

RiskIndicator.propTypes = {
    riskValue: PropTypes.number,
    regulatoryTextKeyArray: PropTypes.array,
    isAlternativeFund: PropTypes.bool,
};

module.exports = RiskIndicator;
